import Axios from "axios";
import { ApiBaseUrl, BranchUrl, Iban } from "../config/config";
import { ApiResultModel } from "../models/common.model";
import {
  GetIbanRequest,
  GetIbanResponse,
  IbanFilter,
  IbanIdForBranchesRequest,
  IbanIdRequest,
  IbanRequest,
} from "../models/iban.model";
import { BranchAndStoreAccessResponse } from "../models/supplierUserBarnch.model";
import { UpdateBranchesIbanRequest } from "../models/branch.model";

export const CreateIban = async (data: IbanRequest): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + Iban + "/CreateIban",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const DeleteIban = async (data: IbanIdRequest): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + Iban + "/DeleteIban",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetIbans = async (
  data: GetIbanRequest
): Promise<ApiResultModel<GetIbanResponse[]>> => {
  return await Axios.post<ApiResultModel<GetIbanResponse[]>>(
    ApiBaseUrl + Iban + "/GetIbans",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetIbanExcel = async (data: IbanFilter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + Iban + "/GetIbansExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${"لیست شماره شبا"}.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};

export const GetIbanById = async (
  data: IbanIdRequest
): Promise<GetIbanResponse> => {
  return await Axios.post<ApiResultModel<GetIbanResponse>>(
    ApiBaseUrl + Iban + "/GetIbanById",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetBranchAndStoresByIbanId = async (
  data: IbanIdForBranchesRequest
): Promise<BranchAndStoreAccessResponse[]> => {
  return await Axios.post<ApiResultModel<BranchAndStoreAccessResponse[]>>(
    ApiBaseUrl + Iban + "/GetBranchAndStoresByIbanId",
    data
  ).then((result) => {
    return result.data.data;
  });
};
